import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Css/ProjectSpending.css";
import "./Css/ProjectSpending-responsive.css";

import { Ripple } from "primereact/ripple";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { Image } from "primereact/image";

import NoDataCreated from "../../../Components/NoDataCreated";
import ErrorPage from "../../../Components/ErrorPage";
import { goToTop } from "../../../Components/goToTop";
import { baseURL } from "../../../Api/ApiConstant";
import { formatDate, parseStringToDate } from "../../../Utils/getDate";
import NumberInput from "../../../Components/NumberInput";
import TextInput from "../../../Components/TextInput";
import FileInput from "../../../Components/FileInput";
import DatePicker from "../../../Components/DatePicker";
import PageLoader from "../../../Components/PageLoader";
import DocumentViewModal from "../../../Components/DocumentViewModal";
import { getAppCurrencyType } from "../../../Utils/Common";

import {
  addLabourDetails,
  addMpurchaseDetails,
  addOtherDetails,
  addProjctSpendingShop,
  projectSpendingDetalsDelete,
  shareProjectSpending,
  updateLabourDetails,
  updateMpurchaseDetails,
  updateOtherDetails,
} from "../../../Api/HeyTraderService/ProjectSpendingService";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import {
  getAllSpendingProjectList,
  getAllSpendingShopList,
} from "../../../Controllers/Thunks/HeyTraderThunks";
import { ProjectSpendingTypes } from "../../../Controllers/Types/HeyTraderTypes/ProjectSpending/ProjectSpendingTypes";
import { ProjectSpendingDataType } from "../../../Controllers/Types/HeyTraderTypes/ProjectSpending/ProjectSpendingDataType";
import {
  checkFileOthers,
  checkModelSelected,
  checkNumber,
  checkText,
} from "../../../Utils/Validator";

import { PojectSpendingShopType } from "../../../Controllers/Types/HeyTraderTypes/ProjectSpending/PojectSpendingShopType";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import { mapShareContactType, ShareContactType } from "../../../Controllers/Types/Share/ShareContactType";
import ShareModal from "../../../Components/ShareModal";
import { ShareContactTypes } from "../../../Controllers/Types/HeyTraderTypes/ShareContactTypes";

const ProjectSpending: React.FC = () => {
  const today = new Date();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const toast = useRef<Toast>(null);
  const currencySymbol = getAppCurrencyType();

  const loadingPage = "";
  const error = "";
  const [loading, setLoading] = useState<boolean>(false);
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const [customCreateLoading, setCustomCreateLoading] = useState<boolean>(false);

  const [spendingViewState, setSpendingViewState] = useState<"M Purchase" | "Labour" | "Others">("M Purchase");

  const [spendingProjectDetails, setSpendingProjectDetails] = useState<ProjectSpendingTypes | null>(null);

  const [owanProject, setOwanProject] = useState<boolean>(false);
  const [addOptions, setAddOptions] = useState<number>(0);

  const [spendingTotal, setSpendingTotal] = useState<number>(0);
  const [projectSpendingSearchKey, setProjectSpendingSearchKey] = useState<string>("");
  const [documentFileUrl, setDocumentFileUrl] = useState<string>("");
  const [showDocViewModal, setShowDocViewModal] = useState<boolean>(false);

  /* M Purchase */
  const [mPurchaseViewState, setMPurchaseViewState] = useState<"All" | "Building material" | "Client material">("All");
  const [mPurchaseData, setMPurchaseData] = useState<ProjectSpendingDataType[]>([]);
  const [filteredmPurchaseData, setFilteredMPurchaseData] = useState<ProjectSpendingDataType[]>([]);
  const [selectedMPurchaseData, setSelectedMPurchaseData] = useState<ProjectSpendingDataType | null>(null);
  const [showMPurchaseModal, setShowMPurchaseModal] = useState<boolean>(false);
  const [mPurchaseSubtotal, setMPurchaseSubtotal] = useState<number>(0);
  const [shopsData, setShopsData] = useState<PojectSpendingShopType[]>([]);
  const [filteredShopsData, setFilteredShopsData] = useState<PojectSpendingShopType[]>([]);
  const [showShopsModal, setShowShopsModal] = useState<boolean>(false);
  const [shopSearchKey, setShopSearchKey] = useState<string>("");
  const [customShopName, setCustomShopName] = useState<string>("");
  const [customShopNameError, setCustomShopNameError] = useState<string>("");

  // mpurchase input values
  const [mPurchaseDate, setMPurchaseDate] = useState<Nullable<Date>>(today);
  const [selectedShop, setSelectedShop] = useState<PojectSpendingShopType | null>(null);
  const [materialType, setMaterialType] = useState<string>("Building material");
  const [mPurchaseTitle, setMPurchaseTitle] = useState<string>("");
  const [mPurchaseAmount, setMPurchaseAmount] = useState<number | null>(null);
  const [mPurchaseFile, setMPurchaseFile] = useState<File | null>(null);
  const [mPurchaseFileName, setMPurchaseFileName] = useState<string>("");

  // mpurchase error messages
  const [mPurchaseDateError, setMPurchaseDateError] = useState<string>("");
  const [mPurchaseShopError, setMPurchaseShopError] = useState<string>("");
  const [mPurchaseMaterialTypeError, setMPurchaseMaterialTypeError] = useState<string>("");
  const [mPurchaseTitleError, setMPurchaseTitleError] = useState<string>("");
  const [mPurchaseAmountError, setMPurchaseAmountError] = useState<string>("");
  const [mPurchaseFileError, setMPurchaseFileError] = useState<string>("");

  /* Labour */
  const [labourData, setLabourData] = useState<ProjectSpendingDataType[]>([]);
  const [filteredLabourData, setFilteredLabourData] = useState<ProjectSpendingDataType[]>([]);
  const [selectedLabourData, setSelectedLabourData] = useState<ProjectSpendingDataType | null>(null);
  const [labourSubtotal, setLabourSubtotal] = useState<number>(0);
  const [showLabourModal, setShowLabourModal] = useState<boolean>(false);
  const [labourDate, setLabourDate] = useState<Nullable<Date>>(today);
  const [labourTitle, setLabourTitle] = useState<string>("");
  const [labourAmount, setLabourAmount] = useState<number | null>(null);
  const [labourFile, setLabourFile] = useState<File | null>(null);
  const [labourFileName, setLabourFileName] = useState<string>("");

  const [labourDateError, setLabourDateError] = useState<string>("");
  const [labourTitleError, setLabourTitleError] = useState<string>("");
  const [labourAmountError, setLabourAmountError] = useState<string>("");
  const [labourFileError, setLabourFileError] = useState<string>("");

  /* Others */
  const [othersData, setOthersData] = useState<ProjectSpendingDataType[]>([]);
  const [filteredOthersData, setFilteredOthersData] = useState<ProjectSpendingDataType[]>([]);
  const [selectedOthersData, setSelectedOthersData] = useState<ProjectSpendingDataType | null>(null);
  const [othersSubtotal, setOthersSubtotal] = useState<number>(0);
  const [showOthersModal, setShowOthersModal] = useState<boolean>(false);
  const [othersDate, setOthersDate] = useState<Nullable<Date>>(today);
  const [othersTitle, setOthersTitle] = useState<string>("");
  const [othersAmount, setOthersAmount] = useState<number | null>(null);
  const [othersFile, setOthersFile] = useState<File | null>(null);
  const [othersFileName, setOthersFileName] = useState<string>("");

  const [othersDateError, setOthersDateError] = useState<string>("");
  const [othersTitleError, setOthersTitleError] = useState<string>("");
  const [othersAmountError, setOthersAmountError] = useState<string>("");
  const [othersFileError, setOthersFileError] = useState<string>("");

  /* Contact share */
  const [contactsData, setContactsData] = useState<ShareContactTypes[]>([]);

  // const [checkedContacts, setCheckedContacts] = useState<number[]>([]);
  // const [filteredContactsData, setFilteredContactsData] = useState<ShareContactTypes[]>([]);
  const [showContactShareModal, setShowContactShareModal] = useState<boolean>(false);



  const [activeContactTab, setActiveContactTab] = useState<"All" | "Employee" | "Professional" | "Client">("All");

  const [navigateFrom, setNavigateFrom] = useState<string | null>(null);
  const [updateHasChanges, setUpdateHasChanges] = useState<boolean>(false);


  // new share feature

  const [projectContactIds, setProjectContactIds] = useState<number[]>([]);
  //shared list contents
  const [sharedList, setSharedList] = useState<ShareContactType[]>([]);




  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const add_data_material = (useCanEdit("Project Spending", "add_material_purchase") || (location.state.projectData.can_edit === true));
  const edit_data_material = (useCanEdit("Project Spending", "edit_material_purchase") || (location.state.projectData.can_edit === true));
  const delete_data_material = (useCanEdit("Project Spending", "delete_material_purchase") || (location.state.projectData.can_edit === true));
  const add_data_labour = (useCanEdit("Project Spending", "add_labour_spending") || (location.state.projectData.can_edit === true));
  const edit_data_labour = (useCanEdit("Project Spending", "edit_labour_spending") || (location.state.projectData.can_edit === true));
  const delete_data_labour = (useCanEdit("Project Spending", "delete_labour_spending") || (location.state.projectData.can_edit === true));
  const add_data_other = (useCanEdit("Project Spending", "add_other_spending") || (location.state.projectData.can_edit === true));
  const edit_data_other = (useCanEdit("Project Spending", "edit_other_spending") || (location.state.projectData.can_edit === true));
  const delete_data_other = (useCanEdit("Project Spending", "delete_other_spending") || (location.state.projectData.can_edit === true));
  const add_data_quotation = (useCanEdit("Project Spending", "add_quotations") || (location.state.projectData.can_edit === true));
  const share_data = useCanEdit("Project Spending", "share_details");


  // restore project information.
  useEffect(() => {
    if (location.state && location.state.openStatus) {
      const status: number = location.state.openStatus;
      setAddOptions(status);
    }

    if (location?.state && location?.state?.navigateFrom) {
      setNavigateFrom(location?.state?.navigateFrom)
    } else {
      setNavigateFrom(null);
    }
  }, [location.state]);

  useEffect(() => {
    if (addOptions === 1) {
      //  open add form model.
      setShowMPurchaseModal(true);
      setDataState("Add");
    }
  }, [addOptions]);


  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(getAllSpendingProjectList());
    dispatch(getAllSpendingShopList());
  }, [dispatch]);

  // this is get data from state list and set projectlist
  const shopList = useAppSelector(
    (state) => state.projctSpendingShops.shopList
  );

  // my action for fetch project by state list
  const ProjectsListFromStore = useAppSelector(
    (state) => state.projectSpending.spendingProjectList
  );

  // find project from globle object list.
  useEffect(() => {
    const globleproject = location.state.projectData as ProjectSpendingTypes;

    setOwanProject(globleproject.is_own_project);
    const projectfromState = ProjectsListFromStore.filter(
      (e) => e.project_id === globleproject.project_id
    );
    if (projectfromState.length > 0) {
      setSpendingProjectDetails(projectfromState[0]);
    } else {
      setSpendingProjectDetails(globleproject);
    }
  }, [ProjectsListFromStore, location.state]);

  //this function depands on spending project details when changes happend.
  useEffect(() => {
    if (spendingProjectDetails && spendingProjectDetails !== null) {
      setMPurchaseData(spendingProjectDetails?.m_purchase || []);
      setLabourData(spendingProjectDetails?.labour || []);
      setOthersData(spendingProjectDetails?.others || []);
      setSpendingTotal(spendingProjectDetails?.total_spending || 0);
    } else {
      setMPurchaseData([]);
      setLabourData([]);
      setOthersData([]);
      setSpendingTotal(0);
    }
  }, [spendingProjectDetails]);



  // refill shared list data
  useEffect(() => {
    if (!spendingProjectDetails) return;
    const shareList = spendingProjectDetails.share_list ?? [];
    if (shareList.length > 0) {
      const results: ShareContactType[] = shareList.map((e) => {
        const dt: Partial<ShareContactType> = {
          id: e.id,
          first_name: e.first_name,
          last_name: e.last_name!,
          profile_image: e.profile_image,
          email: e.email!,
          type: e.main_type!,
          by: e.by,
          can_edit: e.can_edit,
          can_view: 1, // forcing as "viewable"
        };

        return mapShareContactType(dt);
      });
      setSharedList(results);
    } else {
      setSharedList([]); // clear if no share list
    }
  }, [spendingProjectDetails]);



  useEffect(() => {
    if (
      spendingViewState === "M Purchase" &&
      filteredmPurchaseData &&
      filteredmPurchaseData?.length > 0
    ) {
      setMPurchaseSubtotal(
        filteredmPurchaseData.reduce((acc, curr) => acc + (curr.amount || 0), 0)
      );
    } else {
      setMPurchaseSubtotal(0);
    }

    if (
      spendingViewState === "Labour" &&
      filteredLabourData &&
      filteredLabourData?.length > 0
    ) {
      setLabourSubtotal(
        filteredLabourData.reduce((acc, curr) => acc + (curr.amount || 0), 0)
      );
    } else {
      setLabourSubtotal(0);
    }

    if (
      spendingViewState === "Others" &&
      filteredOthersData &&
      filteredOthersData?.length > 0
    ) {
      setOthersSubtotal(
        filteredOthersData.reduce((acc, curr) => acc + (curr.amount || 0), 0)
      );
    } else {
      setOthersSubtotal(0);
    }
  }, [
    spendingViewState,
    filteredLabourData,
    filteredOthersData,
    filteredmPurchaseData,
  ]);

  const handleChangeSpendingViewState = (
    state: "M Purchase" | "Labour" | "Others"
  ) => {
    setSpendingViewState(state);
    setProjectSpendingSearchKey("");
    goToTop();
  };

  const handleNavigateQuotation = () => {
    const globleproject = location.state.projectData as ProjectSpendingTypes;
    navigate(`/project-spending/quotation`, {
      state: { projectDetail: globleproject, navigateFrom: navigateFrom ? navigateFrom : null },
    });
    goToTop();
  };

  const handleCloseDocViewModal = () => {
    setShowDocViewModal(false);
    setDocumentFileUrl("");
  };

  const handleViewDocumentFile = (fileUrl: string) => {
    if (fileUrl && fileUrl !== "") {
      setShowDocViewModal(true);
      setDocumentFileUrl(baseURL + fileUrl);
    } else {
      setShowDocViewModal(false);
      setDocumentFileUrl("");
    }
  };

  /* Contact */
  useEffect(() => {
    const globleproject = location.state.projectData as ProjectSpendingTypes;
    setContactsData(globleproject.contact);
  }, [location.state]);

  // reupdate
  useEffect(() => {
    const globleproject = location.state.projectData as ProjectSpendingTypes;
    const projectfromState = ProjectsListFromStore.filter((e) => e.project_id === globleproject.project_id);
    if (projectfromState.length > 0) {
      const projectx = projectfromState[0];
      setSpendingProjectDetails(projectx);
    }
  }, [ProjectsListFromStore]);


  // project contact ids set
  useEffect(() => {
    setContactsData(spendingProjectDetails?.contact || []);
  }, [spendingProjectDetails])

  // get project contact ids
  useEffect(() => {
    if (contactsData && contactsData.length > 0) {
      const ids = contactsData.map((e) => e.id)
      setProjectContactIds(ids);
    }
  }, [contactsData])



  // new share options
  // top area

  /* Share  */
  const handleCloseShareModal = () => {
    setShowContactShareModal(false);
  }

  const handleShareQuotation = () => {
    setShowContactShareModal(true);
    // setSelectedProject(project);
  }



  // database function
  const shareDataFunction = async (selectedContacts: ShareContactType[]) => {
    try {
      // get only ticked data as well
      const sendData = selectedContacts.filter((e) => e.can_view != 0 || e.can_edit != 0)

      if (sendData && sendData?.length > 0) {
        const data = await shareProjectSpending(
          sendData,
          spendingProjectDetails?.project_id!

        );
        if (data.statusCode === 200) {
          setLoading(false);
          handleCloseShareModal();
          dispatch(getAllSpendingProjectList());

          if (toast.current) {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Quotation shared successfully.',
              life: 3000
            });
          }
        }
      }

    } catch (error) {
      setLoading(false);

      if (toast.current) {
        toast.current.show({
          severity: 'error',
          summary: 'Failed',
          detail: 'There was an error sharing the quotation.',
          life: 3000
        });
      }
    }
  }
  /*  */




  /* Common Validation funtions */
  function checkCredentials(checkfor: string): boolean {
    if (checkfor === "m_purchase") {
      const isDate = checkText(formatDate(mPurchaseDate!), true, setMPurchaseDateError);
      const isShop = checkModelSelected(selectedShop != null, true, setMPurchaseShopError);
      const isMaterialType = checkText(materialType, true, setMPurchaseMaterialTypeError);
      const isMpurchaseTitle = checkText(mPurchaseTitle, true, setMPurchaseTitleError);
      const isMpurchaseAmount = checkNumber(mPurchaseAmount!, true, setMPurchaseAmountError);
      const isMpurchaseFile = checkFileOthers(mPurchaseFile!, false, setMPurchaseFileError);

      return (
        isDate &&
        isShop &&
        isMaterialType &&
        isMpurchaseTitle &&
        isMpurchaseAmount &&
        isMpurchaseFile
      );
    } else if (checkfor === "labour") {
      const isDate = checkText(formatDate(labourDate!), true, setLabourDateError);
      const isLabourTitle = checkText(labourTitle, true, setLabourTitleError);
      const isLabourAmount = checkNumber(labourAmount!, true, setLabourAmountError);
      const isLabourFile = checkFileOthers(mPurchaseFile!, false, setLabourFileError);

      return (
        isDate &&
        isLabourTitle &&
        isLabourAmount &&
        isLabourFile
      );
    } else if (checkfor === "others") {
      const isDate = checkText(formatDate(othersDate!), true, setOthersDateError);
      const isOtherTitle = checkText(othersTitle, true, setOthersTitleError);
      const isOtherAmount = checkNumber(othersAmount!, true, setOthersAmountError);
      const isOtherFile = checkFileOthers(othersFile!, false, setOthersFileError);

      return (
        isDate &&
        isOtherAmount &&
        isOtherTitle &&
        isOtherFile
      );
    } else {
      return false;
    }
  }

  function showAPIErrors(checkfor: 'm_purchase' | 'labour' | 'others', keyName: string, error: string): void {
    if (checkfor === 'm_purchase') {
      if (keyName === "date") {
        setMPurchaseDateError(error);
      }
      if (keyName === "shop_id") {
        setMPurchaseShopError(error);
      }
      if (keyName === "material_type") {
        setMPurchaseMaterialTypeError(error);
      }
      if (keyName === "title") {
        setMPurchaseTitleError(error);
      }
      if (keyName === "amount") {
        setMPurchaseAmountError(error);
      }
      if (keyName === "file") {
        setMPurchaseFileError(error);
      }
    }

    if (checkfor === 'labour') {
      if (keyName === "date") {
        setLabourDateError(error);
      }
      if (keyName === "title") {
        setLabourTitleError(error);
      }
      if (keyName === "amount") {
        setLabourAmountError(error);
      }
      if (keyName === "file") {
        setLabourFileError(error);
      }
    }

    if (checkfor === 'others') {
      if (keyName === "date") {
        setOthersDateError(error);
      }
      if (keyName === "title") {
        setOthersTitleError(error);
      }
      if (keyName === "amount") {
        setOthersAmountError(error);
      }
      if (keyName === "file") {
        setOthersFileError(error);
      }
    }
  }
  /*  */

  /* ******************************* M Purchase ******************************** */
  useEffect(() => {
    if (mPurchaseData && mPurchaseData?.length > 0) {
      if (mPurchaseViewState === "All") {
        const filteredData = mPurchaseData?.filter((mPurchase) =>
          mPurchase
            ?.title!.toLowerCase()
            .includes(projectSpendingSearchKey.toLowerCase())
        );
        setFilteredMPurchaseData(filteredData);
      } else if (mPurchaseViewState === "Building material") {
        const filteredData = mPurchaseData?.filter(
          (mPurchase) =>
            mPurchase.material_type === "Building material" &&
            mPurchase
              ?.title!.toLowerCase()
              .includes(projectSpendingSearchKey.toLowerCase())
        );
        setFilteredMPurchaseData(filteredData);
      } else if (mPurchaseViewState === "Client material") {
        const filteredData = mPurchaseData?.filter(
          (mPurchase) =>
            mPurchase.material_type === "Client material" &&
            mPurchase
              ?.title!.toLowerCase()
              .includes(projectSpendingSearchKey.toLowerCase())
        );
        setFilteredMPurchaseData(filteredData);
      } else {
        setFilteredMPurchaseData(mPurchaseData);
      }
    } else {
      setFilteredMPurchaseData([]);
    }
  }, [mPurchaseData, mPurchaseViewState, projectSpendingSearchKey]);

  /* Shops */
  useEffect(() => {
    const fetchShopsData = async () => {
      const activeShops = shopList?.filter((shop) => shop?.status === 1);
      setShopsData(activeShops);
    };

    fetchShopsData();
  }, [shopList]);

  useEffect(() => {
    if (shopsData && shopsData?.length > 0) {
      const filteredShops = shopsData.filter((shop) =>
        shop?.shop_name!.toLowerCase().includes(shopSearchKey.toLowerCase())
      );
      setFilteredShopsData(filteredShops);
    } else {
      setFilteredShopsData([]);
    }
  }, [shopsData, shopSearchKey]);

  const handleCloseShopsModal = () => {
    setShowShopsModal(false);
    setShopSearchKey("");

    handleResetCustomShopFields();
  };

  const handleResetCustomShopFields = () => {
    setCustomShopName("");
    setCustomShopNameError("");
  };

  const handleAddShop = () => {
    setShowShopsModal(true);
  };

  const handleSelectShop = (shop: PojectSpendingShopType) => {
    setSelectedShop(shop);

    setTimeout(() => {
      handleCloseShopsModal();
    }, 200);
  };

  // shop name create functions
  const handleCreateCustomShop = async (e: React.FormEvent) => {
    e.preventDefault();

    if (customShopName !== "") {
      setCustomCreateLoading(true);

      const data = await addProjctSpendingShop(customShopName);

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllSpendingShopList());

        setCustomCreateLoading(false);
        handleResetCustomShopFields();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Shop added successfully.",
            life: 3000,
          });
        }
      } else {
        setCustomCreateLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error adding the shop.",
            life: 3000,
          });
        }
      }
    }
  };
  /*  */

  const handleSwitchMPurchaseViewState = (state: "All" | "Building material" | "Client material") => {
    setMPurchaseViewState(state);
    setProjectSpendingSearchKey("");
    goToTop();
  };

  const handleCloseMPurchaseModal = () => {
    setShowMPurchaseModal(false);

    handleResetMPurchaseFormFields();
    handleResetMPurchaseErrors();
  };

  const handleResetMPurchaseFormFields = () => {
    setMPurchaseDate(today);
    setSelectedShop(null);
    setMaterialType("Building material");
    setMPurchaseTitle("");
    setMPurchaseAmount(null);
    setMPurchaseFile(null);
    setMPurchaseFileName("");
  };

  const handleResetMPurchaseErrors = () => {
    setMPurchaseDateError("");
    setMPurchaseShopError("");
    setMPurchaseMaterialTypeError("");
    setMPurchaseTitleError("");
    setMPurchaseAmountError("");
    setMPurchaseFileError("");
  };

  const handleAddMPurchase = () => {
    setShowMPurchaseModal(true);
    setDataState("Add");
  };

  /* validation text handler for mpurchase */
  useEffect(() => {
    checkText(formatDate(mPurchaseDate!), false, setMPurchaseDateError);
  }, [mPurchaseDate]);

  useEffect(() => {
    checkModelSelected(selectedShop != null, false, setMPurchaseShopError);
  }, [selectedShop]);

  useEffect(() => {
    checkText(materialType, false, setMPurchaseMaterialTypeError);
  }, [materialType]);

  useEffect(() => {
    checkText(mPurchaseTitle, false, setMPurchaseTitleError);
  }, [mPurchaseTitle]);

  useEffect(() => {
    checkNumber(mPurchaseAmount!, false, setMPurchaseAmountError);
  }, [mPurchaseAmount]);

  useEffect(() => {
    checkFileOthers(mPurchaseFile!, false, setMPurchaseFileError);
  }, [mPurchaseFile]);
  /*  */

  // m_purchase save function called.
  const handleCreateMPurchase = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials("m_purchase")) {
      setLoading(true);

      const data = await addMpurchaseDetails(
        spendingProjectDetails?.project_id!,
        formatDate(mPurchaseDate!),
        selectedShop?.id!,
        materialType,
        mPurchaseTitle,
        mPurchaseAmount!,
        mPurchaseFile!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllSpendingProjectList());

        setLoading(false);
        handleCloseMPurchaseModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Material purchase created successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        setLoading(false);
        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors('m_purchase', key, value[0])
        ))
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the material purchase.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditMPurchase = (data: ProjectSpendingDataType) => {
    if (data) {
      setSelectedMPurchaseData(data);
      setShowMPurchaseModal(true);
      setDataState("Edit");

      setMPurchaseDate(parseStringToDate(data?.date!) || null);
      setSelectedShop(data?.spending_shop || null);
      setMaterialType(data?.material_type!);
      setMPurchaseTitle(data?.title || "");
      setMPurchaseAmount(data?.amount || null);
    } else {
      setSelectedMPurchaseData(null);
      setMPurchaseDate(null);
      setSelectedShop(null);
      setMaterialType("Building material");
      setMPurchaseTitle("");
      setMPurchaseAmount(null);
    }
  };

  const handleUpdateMPurchase = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials("m_purchase")) {
      setLoading(true);

      const data = await updateMpurchaseDetails(
        spendingProjectDetails?.project_id!,
        formatDate(mPurchaseDate!),
        selectedShop?.id!,
        materialType,
        mPurchaseTitle,
        mPurchaseAmount!,
        mPurchaseFile!,
        selectedMPurchaseData?.id!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllSpendingProjectList());

        setLoading(false);
        handleCloseMPurchaseModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Material purchase updated successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        setLoading(false);

        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors('m_purchase', key, value[0])
        ))
      } else {
        setLoading(false);

        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the material purchase.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteMPurchase = (data: ProjectSpendingDataType) => {
    const mPurchaseId = data?.id;

    confirmDialog({
      message: "Are you sure you want to delete this record?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteMPurchase(mPurchaseId!),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteMPurchase = async (mPurchaseId: number) => {
    //  action here for delete
    const result = await projectSpendingDetalsDelete(mPurchaseId);

    if (result.statusCode === 200) {
      dispatch(getAllSpendingProjectList());

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the record.",
          life: 3000,
        });
      }
    }
  };

  const mPurchaseModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} material purchase</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseMPurchaseModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const mPurchaseModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseMPurchaseModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateMPurchase : handleUpdateMPurchase}
        loading={loading}
        className="custom_btn primary"
        disabled={spendingViewState === 'M Purchase' && dataState === 'Edit' && !updateHasChanges}
      />
    </div>
  );

  const handleMPurchaseFileUpload = (file: File) => {
    setMPurchaseFile(file);
    setMPurchaseFileName(file.name);
  };

  const handleClearMPurchaseFile = () => {
    setMPurchaseFile(null);
    setMPurchaseFileName("");
  };

  const handleMPurchaseAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setMPurchaseAmount(e.value);
    } else {
      setMPurchaseAmount(null);
    }
  };

  const handleChangeMaterialtype = (e: CheckboxChangeEvent, option: "Building material" | "Client material") => {
    setMaterialType(option);
  };

  const mPurchaseFileBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    const file = data?.file;
    const fileExt = data?.file_extension;

    return (
      <div className="table_file_view_area">
        {file && file !== null ? (
          <React.Fragment>
            {fileExt === "pdf" ? (
              <div
                className="item_file_container"
                onClick={() => handleViewDocumentFile(file!)}
              >
                <i className="bi bi-file-earmark-pdf doc_icon"></i>
              </div>
            ) : (
              <div className="note_image_container">
                <Image src={baseURL + file} className="note_img" preview />
              </div>
            )}
          </React.Fragment>
        ) : (
          <span className="no_image_text">---</span>
        )}
      </div>
    );
  };

  const mPurchaseTableActionBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    return (
      <React.Fragment>
        <Tooltip target=".data_action_btn" />

        <div className="tabel_btn_area custom mt-1 mb-1">
          {edit_data_material && (owanProject || spendingProjectDetails?.can_edit === true) && (
            <button
              className="data_action_btn with_bg primary_table_btn p-ripple"
              onClick={() => handleEditMPurchase(data)}
              data-pr-tooltip={`Edit`}
              data-pr-position="top"
            >
              <i className="bi bi-pencil-square"></i>
              <Ripple />
            </button>
          )}

          {delete_data_material && (owanProject || spendingProjectDetails?.can_edit === true) && (
            <button
              className="data_action_btn with_bg danger_table_btn p-ripple"
              onClick={() => handleDeleteMPurchase(data)}
              data-pr-tooltip={`Delete`}
              data-pr-position="top"
            >
              <i className="bi bi-trash3"></i>
              <Ripple />
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };
  /* *************************************************************************** */

  /* ********************************* Labour ********************************** */
  useEffect(() => {
    if (
      spendingViewState === "Labour" &&
      labourData &&
      labourData?.length > 0
    ) {
      const filteredData = labourData?.filter((labour) =>
        labour
          ?.title!.toLowerCase()
          .includes(projectSpendingSearchKey.toLowerCase())
      );
      setFilteredLabourData(filteredData);
    }
  }, [spendingViewState, labourData, projectSpendingSearchKey]);


  /* validation handler for lobour */
  useEffect(() => {
    checkText(formatDate(labourDate!), false, setLabourDateError);
  }, [labourDate]);

  useEffect(() => {
    checkText(labourTitle, false, setLabourTitleError);
  }, [labourTitle]);

  useEffect(() => {
    checkNumber(labourAmount!, false, setLabourAmountError);
  }, [labourAmount]);

  useEffect(() => {
    checkFileOthers(mPurchaseFile!, false, setLabourFileError);
  }, [mPurchaseFile]);
  /*  */


  const handleCloseLabourModal = () => {
    setShowLabourModal(false);

    handleResetLabourFormFields();
    handleResetLabourErrors();
  };

  const handleResetLabourFormFields = () => {
    setLabourDate(today);
    setLabourTitle("");
    setLabourAmount(null);
    setLabourFile(null);
    setLabourFileName("");
  };

  const handleResetLabourErrors = () => {
    setLabourDateError("");
    setLabourTitleError("");
    setLabourAmountError("");
    setLabourFileError("");
  };

  const handleAddLabour = () => {
    setShowLabourModal(true);
    setDataState("Add");
  };

  const handleCreateLabour = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials("labour")) {
      setLoading(true);

      const data = await addLabourDetails(
        spendingProjectDetails?.project_id!,
        formatDate(labourDate!),
        labourTitle,
        labourAmount!,
        labourFile!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllSpendingProjectList());

        setLoading(false);
        handleCloseLabourModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data created successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        setLoading(false);

        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors('labour', key, value[0])
        ))
      } else {
        setLoading(false);

        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the data.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditLabour = (data: ProjectSpendingDataType) => {
    if (data) {
      setSelectedLabourData(data);
      setShowLabourModal(true);
      setDataState("Edit");

      setLabourDate(parseStringToDate(data?.date!) || null);
      setLabourTitle(data?.title || "");
      setLabourAmount(data?.amount || null);
    } else {
      setSelectedLabourData(null);
      setLabourDate(null);
      setLabourTitle("");
      setLabourAmount(null);
    }
  };

  const handleUpdateLabour = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials("labour")) {
      setLoading(true);

      const data = await updateLabourDetails(
        spendingProjectDetails?.project_id!,
        formatDate(labourDate!),
        labourTitle,
        labourAmount!,
        labourFile!,
        selectedLabourData?.id!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllSpendingProjectList());

        setLoading(false);
        handleCloseLabourModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data update successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        setLoading(false);

        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors('labour', key, value[0])
        ))
      } else {
        setLoading(false);

        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the data.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteLabour = (data: ProjectSpendingDataType) => {
    const labourId = data?.id;

    confirmDialog({
      message: "Are you sure you want to delete this record?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteLabour(labourId!),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteLabour = async (labourId: number) => {
    //  action here for delete
    const result = await projectSpendingDetalsDelete(labourId);

    if (result.statusCode === 200) {
      dispatch(getAllSpendingProjectList());

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the record.",
          life: 3000,
        });
      }
    }
  };

  const labourModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} Labour</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseLabourModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const labourModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseLabourModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateLabour : handleUpdateLabour}
        loading={loading}
        className="custom_btn primary"
        disabled={spendingViewState === 'Labour' && dataState === 'Edit' && !updateHasChanges}
      />
    </div>
  );

  const handleLabourFileUpload = (file: File) => {
    setLabourFile(file);
    setLabourFileName(file.name);
  };

  const handleClearLabourFile = () => {
    setLabourFile(null);
    setLabourFileName("");
  };

  const handleLabourAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setLabourAmount(e.value);
    } else {
      setLabourAmount(null);
    }
  };

  const labourFileBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    const file = data?.file;
    const fileExt = data?.file_extension;

    return (
      <div className="table_file_view_area">
        {file && file !== null ? (
          <React.Fragment>
            {fileExt === "pdf" ? (
              <div
                className="item_file_container"
                onClick={() => handleViewDocumentFile(file!)}
              >
                <i className="bi bi-file-earmark-pdf doc_icon"></i>
              </div>
            ) : (
              <div className="note_image_container">
                <Image src={baseURL + file} className="note_img" preview />
              </div>
            )}
          </React.Fragment>
        ) : (
          <span className="no_image_text">---</span>
        )}
      </div>
    );
  };

  const labourTableActionBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    return (
      <React.Fragment>
        <Tooltip target=".data_action_btn" />

        <div className="tabel_btn_area custom mt-1 mb-1">
          {(edit_data_labour && (owanProject || spendingProjectDetails?.can_edit === true)) && (
            <button
              className="data_action_btn with_bg primary_table_btn p-ripple"
              onClick={() => handleEditLabour(data)}
              data-pr-tooltip={`Edit`}
              data-pr-position="top"
            >
              <i className="bi bi-pencil-square"></i>
              <Ripple />
            </button>
          )}

          {(delete_data_labour && (owanProject || spendingProjectDetails?.can_edit === true)) && (
            <button
              className="data_action_btn with_bg danger_table_btn p-ripple"
              onClick={() => handleDeleteLabour(data)}
              data-pr-tooltip={`Delete`}
              data-pr-position="top"
            >
              <i className="bi bi-trash3"></i>
              <Ripple />
            </button>
          )}

        </div>
      </React.Fragment>
    );
  };
  /* *************************************************************************** */


  /* ********************************* Others ********************************** */
  useEffect(() => {
    if (
      spendingViewState === "Others" &&
      othersData &&
      othersData?.length > 0
    ) {
      const filteredData = othersData?.filter((other) =>
        other
          ?.title!.toLowerCase()
          .includes(projectSpendingSearchKey.toLowerCase())
      );
      setFilteredOthersData(filteredData);
    }
  }, [spendingViewState, othersData, projectSpendingSearchKey]);

  /* validation handler for others */
  useEffect(() => {
    checkText(formatDate(othersDate!), false, setOthersDateError);
  }, [othersDate]);

  useEffect(() => {
    checkText(othersTitle, false, setOthersTitleError);
  }, [othersTitle]);

  useEffect(() => {
    checkNumber(othersAmount!, false, setOthersAmountError);
  }, [othersAmount]);

  useEffect(() => {
    checkFileOthers(othersFile!, false, setOthersFileError);
  }, [othersFile]);
  /*  */

  const handleCloseOthersModal = () => {
    setShowOthersModal(false);

    handleResetOthersFormFields();
    handleResetOthersErrors();
  };

  const handleResetOthersFormFields = () => {
    setOthersDate(today);
    setOthersTitle("");
    setOthersAmount(null);
    setOthersFile(null);
    setOthersFileName("");
  };

  const handleResetOthersErrors = () => {
    setOthersDateError("");
    setOthersTitleError("");
    setOthersAmountError("");
    setOthersFileError("");
  };

  const handleAddOthers = () => {
    setShowOthersModal(true);
    setDataState("Add");
  };

  const handleCreateOthers = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials("others")) {
      setLoading(true);

      const data = await addOtherDetails(
        spendingProjectDetails?.project_id!,
        formatDate(othersDate!),
        othersTitle,
        othersAmount!,
        othersFile!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getAllSpendingProjectList());

        setLoading(false);
        handleCloseOthersModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data created successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        setLoading(false);

        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors('others', key, value[0])
        ))
      } else {
        setLoading(false);

        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the data.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditOthers = (data: ProjectSpendingDataType) => {
    if (data) {
      setSelectedOthersData(data);
      setShowOthersModal(true);
      setDataState("Edit");

      setOthersDate(parseStringToDate(data?.date!) || null);
      setOthersTitle(data?.title || "");
      setOthersAmount(data?.amount || null);
    } else {
      setSelectedOthersData(null);
      setOthersDate(null);
      setOthersTitle("");
      setOthersAmount(null);
    }
  };

  const handleUpdateOthers = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials("others")) {
      setLoading(true);

      const data = await updateOtherDetails(
        spendingProjectDetails?.project_id!,
        formatDate(othersDate!),
        othersTitle,
        othersAmount!,
        othersFile!,
        selectedOthersData?.id!
      );

      if (data.statusCode === 200) {
        // call shop dispach event
        dispatch(getAllSpendingProjectList());

        setLoading(false);
        handleCloseOthersModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data updated successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        setLoading(false);

        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors('others', key, value[0])
        ))
      } else {
        setLoading(false);

        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the data.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteOthers = (data: ProjectSpendingDataType) => {
    const otherId = data?.id;

    confirmDialog({
      message: "Are you sure you want to delete this record?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteOthers(otherId!),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteOthers = async (otherId: number) => {
    //  action here for delete
    const result = await projectSpendingDetalsDelete(otherId);

    if (result.statusCode === 200) {
      dispatch(getAllSpendingProjectList());

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the record.",
          life: 3000,
        });
      }
    }
  };

  const othersModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} Others</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseOthersModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const othersModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseOthersModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateOthers : handleUpdateOthers}
        loading={loading}
        className="custom_btn primary"
        disabled={spendingViewState === 'Others' && dataState === 'Edit' && !updateHasChanges}
      />
    </div>
  );

  const handleOthersFileUpload = (file: File) => {
    setOthersFile(file);
    setOthersFileName(file.name);
  };

  const handleClearOthersFile = () => {
    setOthersFile(null);
    setOthersFileName("");
  };

  const handleOthersAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setOthersAmount(e.value);
    }
  };

  const othersFileBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    const file = data?.file;
    const fileExt = data?.file_extension;

    return (
      <div className="table_file_view_area">
        {file && file !== null ? (
          <React.Fragment>
            {fileExt === "pdf" ? (
              <div
                className="item_file_container"
                onClick={() => handleViewDocumentFile(file!)}
              >
                <i className="bi bi-file-earmark-pdf doc_icon"></i>
              </div>
            ) : (
              <div className="note_image_container">
                <Image src={baseURL + file} className="note_img" preview />
              </div>
            )}
          </React.Fragment>
        ) : (
          <span className="no_image_text">---</span>
        )}
      </div>
    );
  };

  const othersTableActionBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    return (
      <React.Fragment>
        <Tooltip target=".data_action_btn" />

        <div className="tabel_btn_area custom mt-1 mb-1">
          {(edit_data_other && (owanProject || spendingProjectDetails?.can_edit === true)) && (
            <button
              className="data_action_btn with_bg primary_table_btn p-ripple"
              onClick={() => handleEditOthers(data)}
              data-pr-tooltip={`Edit`}
              data-pr-position="top"
            >
              <i className="bi bi-pencil-square"></i>
              <Ripple />
            </button>
          )}

          {(delete_data_other && (owanProject || spendingProjectDetails?.can_edit === true)) && (
            <button
              className="data_action_btn with_bg danger_table_btn p-ripple"
              onClick={() => handleDeleteOthers(data)}
              data-pr-tooltip={`Delete`}
              data-pr-position="top"
            >
              <i className="bi bi-trash3"></i>
              <Ripple />
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };
  /* *************************************************************************** */


  /* **************************** Common functions ***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */


  useEffect(() => {
    if (spendingViewState === 'M Purchase') {
      if (formatDate(mPurchaseDate!) !== selectedMPurchaseData?.date) {
        setUpdateHasChanges(true);
      } else if (selectedShop?.id !== selectedMPurchaseData?.shop_id) {
        setUpdateHasChanges(true);
      } else if (materialType !== selectedMPurchaseData?.material_type) {
        setUpdateHasChanges(true);
      } else if (mPurchaseTitle !== selectedMPurchaseData?.title) {
        setUpdateHasChanges(true);
      } else if (mPurchaseAmount !== selectedMPurchaseData?.amount) {
        setUpdateHasChanges(true);
      } else if (dataState === 'Edit' && (mPurchaseFile !== null && mPurchaseFileName !== '')) {
        setUpdateHasChanges(true);
      } else {
        setUpdateHasChanges(false);
      }
    }

    if (spendingViewState === 'Labour') {
      if (formatDate(labourDate!) !== selectedLabourData?.date) {
        setUpdateHasChanges(true);
      } else if (labourTitle !== selectedLabourData?.title) {
        setUpdateHasChanges(true);
      } else if (labourAmount !== selectedLabourData?.amount) {
        setUpdateHasChanges(true);
      } else if (dataState === 'Edit' && (labourFile !== null && labourFileName !== '')) {
        setUpdateHasChanges(true);
      } else {
        setUpdateHasChanges(false);
      }
    }

    if (spendingViewState === 'Others') {
      if (formatDate(othersDate!) !== selectedOthersData?.date) {
        setUpdateHasChanges(true);
      } else if (othersTitle !== selectedOthersData?.title) {
        setUpdateHasChanges(true);
      } else if (othersAmount !== selectedOthersData?.amount) {
        setUpdateHasChanges(true);
      } else if (dataState === 'Edit' && (othersFile !== null && othersFileName !== '')) {
        setUpdateHasChanges(true);
      } else {
        setUpdateHasChanges(false);
      }
    }
  }, [
    spendingViewState,
    mPurchaseDate,
    selectedShop,
    dataState,
    mPurchaseFile,
    mPurchaseFileName,
    materialType,
    mPurchaseTitle,
    mPurchaseAmount,
    selectedMPurchaseData,

    labourDate,
    labourTitle,
    labourAmount,
    labourFile,
    labourFileName,
    selectedLabourData,

    othersDate,
    othersTitle,
    othersAmount,
    othersFile,
    othersFileName,
    selectedOthersData
  ]);

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {loadingPage ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">
              {navigateFrom && navigateFrom === 'Project' ? (
                <ul className="page_breadcrumb">
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                    {spendingProjectDetails?.job_number + ": " + spendingProjectDetails?.address}
                  </li>
                  <li className="page_breadcrumb_item active">
                    Project spending
                  </li>
                </ul>
              ) : (
                <ul className="page_breadcrumb">
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                    Projects
                  </li>
                  <li className="page_breadcrumb_item has_child">
                    {spendingProjectDetails?.job_number + ": " + spendingProjectDetails?.address}
                  </li>
                  <li className="page_breadcrumb_item active">
                    Project spending
                  </li>
                </ul>
              )}

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_header_area mt-sm-3 mt-3">
              <div className="contact_tabs custom">
                <div className="contact_tab_item">
                  <button
                    type="button"
                    className={`contact_tab_btn fixed_width status_tab ${spendingViewState === "M Purchase" ? "active" : ""
                      } p-ripple`}
                    onClick={() => handleChangeSpendingViewState("M Purchase")}
                  >
                    M Purchase
                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                  </button>
                </div>
                <div className="contact_tab_item">
                  <button
                    type="button"
                    className={`contact_tab_btn fixed_width status_tab ${spendingViewState === "Labour" ? "active" : ""
                      } p-ripple`}
                    onClick={() => handleChangeSpendingViewState("Labour")}
                  >
                    Labour
                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                  </button>
                </div>
                <div className="contact_tab_item">
                  <button
                    type="button"
                    className={`contact_tab_btn fixed_width status_tab ${spendingViewState === "Others" ? "active" : ""
                      } p-ripple`}
                    onClick={() => handleChangeSpendingViewState("Others")}
                  >
                    Others
                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                  </button>
                </div>
              </div>

              <div className="page_action_area full_width">
                <div className="display_label">
                  <span className="display_label_text">Total :&nbsp;</span>
                  <span>
                    {currencySymbol}&nbsp;
                    {spendingTotal.toLocaleString("en-GB", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                {share_data && owanProject && (
                  <button
                    className="add_data_link_btn custom p-ripple"
                    onClick={handleShareQuotation}
                  >
                    <i className="bi bi-share-fill"></i>
                    <span className="btn_text">Share</span>
                    <Ripple />
                  </button>
                )}

                {add_data_quotation && (owanProject || spendingProjectDetails?.can_edit === true) && (
                  <button
                    className="add_data_link_btn custom p-ripple"
                    onClick={handleNavigateQuotation}
                  >
                    <i className="bi bi-list-columns-reverse"></i>
                    <span className="btn_text">Quotation</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            <div className="page_header_area custom mt-sm-3 mt-3">
              <div className="display_label_area">
                <div className="display_label">
                  <span className="display_label_text">Subtotal :&nbsp;</span>
                  {spendingViewState === "M Purchase" ? (
                    <span>
                      {currencySymbol}&nbsp;
                      {mPurchaseSubtotal.toLocaleString("en-GB", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ) : spendingViewState === "Labour" ? (
                    <span>
                      {currencySymbol}&nbsp;
                      {labourSubtotal.toLocaleString("en-GB", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ) : spendingViewState === "Others" ? (
                    <span>
                      {currencySymbol}&nbsp;
                      {othersSubtotal.toLocaleString("en-GB", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="page_action_area">
                <div className="filter_input_group">
                  <IconField iconPosition="right">
                    {projectSpendingSearchKey === "" ? (
                      <InputIcon className="bi bi-search"></InputIcon>
                    ) : (
                      <InputIcon
                        className="bi bi-x-lg search_clear_icon"
                        onClick={() => setProjectSpendingSearchKey("")}
                      ></InputIcon>
                    )}

                    <InputText
                      key={`projectSpendingSearchKey`}
                      id="projectSpendingSearchKey"
                      value={projectSpendingSearchKey}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setProjectSpendingSearchKey(e.target.value)
                      }
                      className="custom_form_input filter_input"
                      placeholder="Search by title"
                      type="search"
                    />
                  </IconField>
                </div>

                {spendingViewState === "M Purchase" && add_data_material && (owanProject || spendingProjectDetails?.can_edit === true) ? (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddMPurchase}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add purchase</span>
                    <Ripple />
                  </button>
                ) : spendingViewState === "Labour" && add_data_labour && (owanProject || spendingProjectDetails?.can_edit === true) ? (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddLabour}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add labour</span>
                    <Ripple />
                  </button>
                ) : spendingViewState === "Others" && add_data_other && (owanProject || spendingProjectDetails?.can_edit === true) ? (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddOthers}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add others</span>
                    <Ripple />
                  </button>
                ) : null}
              </div>
            </div>

            {spendingProjectDetails && spendingProjectDetails !== null && (
              <div className="page_main_content_section p-0">
                {spendingViewState === "M Purchase" ? (
                  <React.Fragment>
                    {mPurchaseData && mPurchaseData?.length > 0 ? (
                      <React.Fragment>
                        <div className="table_tab_filter_container">
                          <div className="table_tab_filter_area">
                            <button
                              className={`table_filter_tab ${mPurchaseViewState === "All" && " active"} p-ripple`}
                              type="button"
                              onClick={() => handleSwitchMPurchaseViewState("All")}
                              role="tab"
                            >
                              All
                              <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                            </button>

                            <span className="table_filter_tab_divider"></span>

                            <button
                              className={`table_filter_tab ${mPurchaseViewState === "Building material" && " active"} p-ripple`}
                              type="button"
                              onClick={() => handleSwitchMPurchaseViewState("Building material")}
                              role="tab"
                            >
                              Building material
                              <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                            </button>

                            <span className="table_filter_tab_divider"></span>

                            <button
                              className={`table_filter_tab ${mPurchaseViewState === "Client material" && " active"} p-ripple`}
                              type="button"
                              onClick={() => handleSwitchMPurchaseViewState("Client material")}
                              role="tab"
                            >
                              Client material
                              <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                            </button>
                          </div>
                        </div>

                        <DataTable
                          value={filteredmPurchaseData}
                          paginator
                          size="small"
                          rows={10}
                          emptyMessage="No records found!"
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          tableStyle={{ minWidth: "50rem" }}
                          paginatorDropdownAppendTo={"self"}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          className="page_table p-0 p-sm-2"
                          rowHover
                          scrollable
                        >
                          {/* <Column
                            header="No."
                            headerClassName="text_purple"
                            className="text_bold"
                            body={(
                              rowData: ProjectSpendingDataType,
                              { rowIndex }
                            ) => <span>{rowIndex + 1}.</span>}
                            style={{ width: "8%" }}
                          ></Column> */}

                          <Column
                            header="Date"
                            headerClassName="text_purple"
                            field="date"
                            body={(rowData: ProjectSpendingDataType) => (
                              <span className="text_no_wrap">
                                {rowData?.date ? rowData?.date : "---"}
                              </span>
                            )}
                            style={{ width: "12%" }}
                          ></Column>

                          <Column
                            header="Shop"
                            headerClassName="text_purple"
                            field="spending_shop.shop_name"
                            body={(rowData: ProjectSpendingDataType) => (
                              <span className="text_nowrap text-capitalize">
                                {rowData?.spending_shop &&
                                  rowData?.spending_shop?.shop_name
                                  ? rowData?.spending_shop?.shop_name
                                  : "---"}
                              </span>
                            )}
                            style={{ width: "20%" }}
                          ></Column>

                          <Column
                            header="Title"
                            headerClassName="text_purple title_column"
                            field="title"
                            body={(rowData: ProjectSpendingDataType) => (
                              <span className="text-capitalize">
                                {rowData?.title ? rowData?.title : "---"}
                              </span>
                            )}
                            style={{ width: "23%" }}
                          ></Column>

                          <Column
                            header="Amount"
                            headerClassName="text_purple"
                            alignHeader={"right"}
                            field="amount"
                            className="text_bold"
                            body={(rowData: ProjectSpendingDataType) => (
                              <span className="text_no_wrap flex_end">
                                {currencySymbol}&nbsp;
                                {rowData?.amount
                                  ? rowData?.amount.toLocaleString("en-GB", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  : "---"}
                              </span>
                            )}
                            style={{ width: "20%" }}
                          ></Column>

                          <Column
                            header="File"
                            headerClassName="text_purple"
                            alignHeader={"center"}
                            field="file"
                            body={mPurchaseFileBody}
                            style={{ width: "12%" }}
                          ></Column>

                          {(edit_data_material || delete_data_material) && (owanProject || spendingProjectDetails?.can_edit === true) && (
                            <Column
                              alignHeader="center"
                              body={mPurchaseTableActionBody}
                              frozen
                              alignFrozen="right"
                            ></Column>
                          )}
                        </DataTable>
                      </React.Fragment>
                    ) : (
                      <NoDataCreated
                        message={`No material purchase data found. To add, click on the Add button.`}
                      />
                    )}
                  </React.Fragment>
                ) : spendingViewState === "Labour" ? (
                  <React.Fragment>
                    {labourData && labourData?.length > 0 ? (
                      <DataTable
                        value={filteredLabourData}
                        paginator
                        size="small"
                        rows={10}
                        emptyMessage="No records found!"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        tableStyle={{ minWidth: "50rem" }}
                        paginatorDropdownAppendTo={"self"}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        className="page_table p-0 p-sm-2"
                        rowHover
                        scrollable
                      >
                        <Column
                          header="No."
                          headerClassName="text_purple"
                          className="text_bold"
                          body={(
                            rowData: ProjectSpendingDataType,
                            { rowIndex }
                          ) => <span>{rowIndex + 1}.</span>}
                          style={{ width: "10%" }}
                        ></Column>

                        <Column
                          header="Date"
                          headerClassName="text_purple"
                          field="date"
                          body={(rowData: ProjectSpendingDataType) => (
                            <span className="text_no_wrap">
                              {rowData?.date ? rowData?.date : "---"}
                            </span>
                          )}
                          style={{ width: "15%" }}
                        ></Column>

                        <Column
                          header="Title"
                          headerClassName="text_purple title_column"
                          field="title"
                          body={(rowData: ProjectSpendingDataType) => (
                            <span className="text-capitalize">
                              {rowData?.title ? rowData?.title : "---"}
                            </span>
                          )}
                          style={{ width: "25%" }}
                        ></Column>

                        <Column
                          header="Amount"
                          headerClassName="text_purple"
                          alignHeader={"right"}
                          field="amount"
                          className="text_bold"
                          body={(rowData: ProjectSpendingDataType) => (
                            <span className="text_no_wrap flex_end">
                              {currencySymbol}&nbsp;
                              {rowData?.amount
                                ? (rowData?.amount).toLocaleString("en-GB", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : "---"}
                            </span>
                          )}
                          style={{ width: "20%" }}
                        ></Column>

                        <Column
                          header="File"
                          headerClassName="text_purple"
                          alignHeader={"center"}
                          field="file"
                          body={labourFileBody}
                          style={{ width: "15%" }}
                        ></Column>

                        {((edit_data_labour || delete_data_labour) && (owanProject || spendingProjectDetails?.can_edit === true)) && (
                          <Column
                            alignHeader="center"
                            body={labourTableActionBody}
                            frozen
                            alignFrozen="right"
                          ></Column>
                        )}
                      </DataTable>
                    ) : (
                      <NoDataCreated
                        message={`No labour(s) data added. To add, click on Add button.`}
                      />
                    )}
                  </React.Fragment>
                ) : spendingViewState === "Others" ? (
                  <React.Fragment>
                    {othersData && othersData?.length > 0 ? (
                      <DataTable
                        value={filteredOthersData}
                        paginator
                        size="small"
                        rows={10}
                        emptyMessage="No records found!"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        tableStyle={{ minWidth: "50rem" }}
                        paginatorDropdownAppendTo={"self"}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        className="page_table p-0 p-sm-2"
                        rowHover
                        scrollable
                      >
                        <Column
                          header="No."
                          headerClassName="text_purple"
                          className="text_bold"
                          body={(
                            rowData: ProjectSpendingDataType,
                            { rowIndex }
                          ) => <span>{rowIndex + 1}.</span>}
                          style={{ width: "10%" }}
                        ></Column>

                        <Column
                          header="Date"
                          headerClassName="text_purple"
                          field="date"
                          body={(rowData: ProjectSpendingDataType) => (
                            <span className="text_no_wrap">
                              {rowData?.date ? rowData?.date : "---"}
                            </span>
                          )}
                          style={{ width: "15%" }}
                        ></Column>

                        <Column
                          header="Title"
                          headerClassName="text_purple title_column"
                          field="title"
                          body={(rowData: ProjectSpendingDataType) => (
                            <span className="text-capitalize">
                              {rowData?.title ? rowData?.title : "---"}
                            </span>
                          )}
                          style={{ width: "25%" }}
                        ></Column>

                        <Column
                          header="Amount"
                          headerClassName="text_purple"
                          alignHeader={"right"}
                          field="amount"
                          className="text_bold"
                          body={(rowData: ProjectSpendingDataType) => (
                            <span className="text_no_wrap flex_end">
                              {currencySymbol}&nbsp;
                              {rowData?.amount
                                ? rowData?.amount.toLocaleString("en-GB", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : "---"}
                            </span>
                          )}
                          style={{ width: "20%" }}
                        ></Column>

                        <Column
                          header="File"
                          headerClassName="text_purple"
                          alignHeader={"center"}
                          field="file"
                          body={othersFileBody}
                          style={{ width: "15%" }}
                        ></Column>

                        {((edit_data_other || delete_data_other) && (owanProject || spendingProjectDetails?.can_edit === true)) && (
                          <Column
                            alignHeader="center"
                            body={othersTableActionBody}
                            frozen
                            alignFrozen="right"
                          ></Column>
                        )}
                      </DataTable>
                    ) : (
                      <NoDataCreated
                        message={`No other(s) data added. To add, click on Add button.`}
                      />
                    )}
                  </React.Fragment>
                ) : null}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Material purchase modal */}
      <Dialog
        visible={showMPurchaseModal}
        headerClassName="custom_modal_header"
        header={mPurchaseModalHeader}
        footer={mPurchaseModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseMPurchaseModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Date */}
              <div className="col-12">
                <DatePicker
                  key={`mPurchaseDate`}
                  id="mPurchaseDate"
                  label="Date"
                  labelHtmlFor="mPurchaseDate"
                  required={true}
                  value={mPurchaseDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setMPurchaseDate}
                  error={mPurchaseDateError}
                  showClear
                  onClear={() => setMPurchaseDate(null)}
                />
              </div>

              {/* Shop */}
              <div className="col-12">
                <div className="page_form_group">
                  <label
                    htmlFor="shop"
                    className="custom_form_label is_required"
                  >
                    Shop
                  </label>
                  <div className="input_with_button_area">
                    <InputText
                      id="shop"
                      value={selectedShop && selectedShop?.shop_name}
                      className="custom_form_input has_add_value text-capitalize"
                      placeholder="Click to select the shop."
                      readOnly={true}
                      autoComplete="off"
                      onClick={handleAddShop}
                    />
                    <button
                      className="add_value_btn p-ripple"
                      onClick={handleAddShop}
                    >
                      {selectedShop === null ? (
                        <React.Fragment>
                          <i className="bi bi-plus-lg"></i>
                          <span>Add</span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <i className="bi bi-pencil-square"></i>
                          <span>Change</span>
                        </React.Fragment>
                      )}
                      <Ripple />
                    </button>
                  </div>

                  {mPurchaseShopError && (
                    <small className="form_error_msg">
                      {mPurchaseShopError}
                    </small>
                  )}
                </div>
              </div>

              {/* Material type */}
              <div className="col-12">
                <div className="page_form_group">
                  <label
                    htmlFor="materialType"
                    className="custom_form_label is_required"
                  >
                    Material Type
                  </label>
                  <div className="response_state_area mb-3">
                    <div className="response_state">
                      <Checkbox
                        inputId="buildingMaterial"
                        name="materialType"
                        value={materialType}
                        onChange={(e) =>
                          handleChangeMaterialtype(e, "Building material")
                        }
                        checked={materialType === "Building material"}
                      />
                      <label htmlFor="buildingMaterial">
                        Building material
                      </label>
                    </div>
                    <div className="response_state">
                      <Checkbox
                        inputId="clientMaterial"
                        name="materialType"
                        value={materialType}
                        onChange={(e) =>
                          handleChangeMaterialtype(e, "Client material")
                        }
                        checked={materialType === "Client material"}
                      />
                      <label htmlFor="clientMaterial">Client material</label>
                    </div>
                  </div>

                  {mPurchaseMaterialTypeError && (
                    <small className="form_error_msg">
                      {mPurchaseMaterialTypeError}
                    </small>
                  )}
                </div>
              </div>

              {/* Title */}
              <div className="col-12">
                <TextInput
                  key={`mPurchaseTitle`}
                  id="mPurchaseTitle"
                  label="Title"
                  labelHtmlFor="mPurchaseTitle"
                  required={true}
                  value={mPurchaseTitle}
                  placeholder="Enter title"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setMPurchaseTitle(e.target.value)
                  }
                  error={mPurchaseTitleError}
                />
              </div>

              {/* Amount */}
              <div className="col-12">
                <NumberInput
                  key={`mPurchaseAmount`}
                  inputId="mPurchaseAmount"
                  label="Amount"
                  labelHtmlFor="mPurchaseAmount"
                  placeholder="Enter amount"
                  onChange={handleMPurchaseAmountChange}
                  value={mPurchaseAmount}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  prefix={currencySymbol + " "}
                  error={mPurchaseAmountError}
                />
              </div>

              {/* File */}
              <div className="col-12">
                <FileInput
                  key={`mPurchaseFile`}
                  id="mPurchaseFile"
                  label="Upload file"
                  labelHtmlFor="mPurchaseFile"
                  required={false}
                  value={mPurchaseFileName}
                  canUploadImage={true}
                  onUpload={handleMPurchaseFileUpload}
                  onClear={handleClearMPurchaseFile}
                  toast={toast}
                  error={mPurchaseFileError}
                  containerClassName="mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Labour modal */}
      <Dialog
        visible={showLabourModal}
        headerClassName="custom_modal_header"
        header={labourModalHeader}
        footer={labourModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseLabourModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Date */}
              <div className="col-12">
                <DatePicker
                  key={`labourDate`}
                  id="labourDate"
                  label="Date"
                  labelHtmlFor="labourDate"
                  required={true}
                  value={labourDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setLabourDate}
                  error={labourDateError}
                  showClear
                  onClear={() => setLabourDate(null)}
                />
              </div>

              {/* Title */}
              <div className="col-12">
                <TextInput
                  key={`labourTitle`}
                  id="labourTitle"
                  label="Title"
                  labelHtmlFor="labourTitle"
                  required={true}
                  value={labourTitle}
                  placeholder="Enter title"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setLabourTitle(e.target.value)
                  }
                  error={labourTitleError}
                />
              </div>

              {/* Amount */}
              <div className="col-12">
                <NumberInput
                  key={`labourAmount`}
                  inputId="labourAmount"
                  label="Amount"
                  labelHtmlFor="labourAmount"
                  placeholder="Enter amount"
                  onChange={handleLabourAmountChange}
                  value={labourAmount}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={0}
                  prefix={currencySymbol + " "}
                  error={labourAmountError}
                />
              </div>

              {/* File */}
              <div className="col-12">
                <FileInput
                  key={`labourFile`}
                  id="labourFile"
                  label="Upload file"
                  labelHtmlFor="labourFile"
                  required={false}
                  value={labourFileName}
                  canUploadImage={true}
                  onUpload={handleLabourFileUpload}
                  onClear={handleClearLabourFile}
                  toast={toast}
                  error={labourFileError}
                  containerClassName="mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Others modal */}
      <Dialog
        visible={showOthersModal}
        headerClassName="custom_modal_header"
        header={othersModalHeader}
        footer={othersModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseOthersModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Date */}
              <div className="col-12">
                <DatePicker
                  key={`othersDate`}
                  id="othersDate"
                  label="Date"
                  labelHtmlFor="othersDate"
                  required={true}
                  value={othersDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setOthersDate}
                  error={othersDateError}
                  showClear
                  onClear={() => setOthersDate(null)}
                />
              </div>

              {/* Title */}
              <div className="col-12">
                <TextInput
                  key={`othersTitle`}
                  id="othersTitle"
                  label="Title"
                  labelHtmlFor="othersTitle"
                  required={true}
                  value={othersTitle}
                  placeholder="Enter title"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setOthersTitle(e.target.value)
                  }
                  error={othersTitleError}
                />
              </div>

              {/* Amount */}
              <div className="col-12">
                <NumberInput
                  key={`othersAmount`}
                  inputId="othersAmount"
                  label="Amount"
                  labelHtmlFor="othersAmount"
                  placeholder="Enter amount"
                  onChange={handleOthersAmountChange}
                  value={othersAmount}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  prefix={currencySymbol + " "}
                  error={othersAmountError}
                />
              </div>

              {/* File */}
              <div className="col-12">
                <FileInput
                  key={`othersFile`}
                  id="othersFile"
                  label="Upload file"
                  labelHtmlFor="othersFile"
                  required={false}
                  value={othersFileName}
                  canUploadImage={true}
                  onUpload={handleOthersFileUpload}
                  onClear={handleClearOthersFile}
                  toast={toast}
                  error={othersFileError}
                  containerClassName="mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Document view modal */}
      <DocumentViewModal
        isOpen={showDocViewModal}
        onClose={handleCloseDocViewModal}
        fileUrl={documentFileUrl}
      />
      {/*  */}

      {/* Shops modal */}
      <Dialog
        visible={showShopsModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseShopsModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"shopSearchKey"}
                id="shopSearchKey"
                value={shopSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setShopSearchKey(e.target.value)
                }
                className="custom_form_input data_search_input"
                placeholder="Search shop by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {shopSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setShopSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseShopsModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input">
            {filteredShopsData && filteredShopsData?.length > 0 ? (
              <div className="data_select_option_area">
                {filteredShopsData?.map((shop) => (
                  <div
                    key={shop?.id}
                    className={`data_select_option p-ripple ${shop?.id === selectedShop?.id ? "selected" : ""}`}
                    onClick={() => handleSelectShop(shop)}
                  >
                    {shop?.shop_name}
                    <Ripple
                      pt={{
                        root: {
                          style: { background: "rgba(164, 96, 253, 0.2)" },
                        },
                      }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer mb-0">
            <div className="input_with_button_area">
              <InputText
                key={`customShopName`}
                id="customShopName"
                value={customShopName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCustomShopName(e.target.value)
                }
                className="custom_form_input has_add_value custom_data_input"
                placeholder="Enter shop name"
                autoComplete="off"
              />
              <button
                className="add_value_btn fill p-ripple"
                onClick={handleCreateCustomShop}
                disabled={customCreateLoading || customShopName === ""}
              >
                {customCreateLoading ? (
                  <span>Processing</span>
                ) : (
                  <React.Fragment>
                    <i className="bi bi-plus-lg"></i>
                    <span>Add</span>
                  </React.Fragment>
                )}
                <Ripple />
              </button>
            </div>
            {customShopNameError && (
              <small className="form_error_msg">{customShopNameError}</small>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Share modal */}
      <ShareModal
        isOpen={showContactShareModal}
        canEditOption={true}
        loading={loading}
        sharedList={sharedList}
        projectContactIds={projectContactIds}
        onClose={handleCloseShareModal}
        onShare={shareDataFunction}
        title="Share Client Account"
      />
      {/*  */}
    </React.Fragment>
  );
};

export default ProjectSpending;
